import { ReactNode } from 'react';
import '../../Button.scss';

export interface IButtonIconProps {
  icon: ReactNode;
}

const ButtonIcon = ({ icon }: IButtonIconProps) => {
  return <div className='button-icon'>{icon}</div>;
};

export default ButtonIcon;
